/* eslint-disable @typescript-eslint/no-empty-interface */
import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateInviteGet = {
  path: "/affiliate/invite",
  method: ERouteHttpVerb.GET
};
export { routeLocationAffiliateInviteGet };